import formatUnits from '#/utils/formatUnits';
import parseUnits from '#/utils/parseUnits';
import { BigNumberish, ethers } from 'ethers';
import { Tooltip } from './v2/tooltip';

interface Props {
  value?: string | null;

  decimals?: BigNumberish;
  maxDecimalDigits?: number;
  suffix?: string | null;
  tooltip?: boolean;
}

export default function EthereumFormatUnitsString({
  value,
  decimals = 18,
  maxDecimalDigits = 5,
  suffix = 'ETH',
  tooltip = false,
}: Props) {
  return value != null ? (
    <Tooltip
      content={
        <span className="truncate">
          {ethers.utils.commify(value)} {suffix}
        </span>
      }
      disabled={!tooltip}
    >
      <span className="truncate">
        {ethers.utils.commify(
          formatUnits(parseUnits(value, decimals), decimals, maxDecimalDigits)
        )}{' '}
        {suffix}
      </span>
    </Tooltip>
  ) : (
    <>-</>
  );
}
